// extracted by mini-css-extract-plugin
export var numpadContainer = "_q9-1";
export var phoneButton = "_q9-0";